"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../../../composite/table/table-cells");
function useColumns() {
    const intl = react_intl_1.useIntl();
    return [
        {
            datakey: 'symbol',
            name: intl.formatMessage({
                id: 'ESS_SHREDDING_MODES_COLUMN_SYMBOL',
                defaultMessage: 'Skartační znak',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'period',
            name: intl.formatMessage({
                id: 'ESS_SHREDDING_MODES_COLUMN_PERIOD',
                defaultMessage: 'Skartační lhůta',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.NumberCell,
            sortable: true,
            filterable: true,
        },
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=shredding-modes-columns.js.map